import asyncActionTypes from '../actions/types.js';

const initialState = {
  amaiaFaqChips: [],
  errorAmaiaFaq: null,
  errorAmaiaResponse: null,
  loadingAmaiaFaq: false,
  loadingAmaiaResponse: false,
  streamingMessage: '',
};

const PantheonData = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_AMAIA_FAQ.START:
      return {
        ...state,
        errorAmaiaFaq: null,
        loadingAmaiaFaq: true,
      };
    case asyncActionTypes.RETRIEVE_AMAIA_FAQ.SUCCESS:
      return {
        ...state,
        amaiaFaqChips: action.payload,
        loadingAmaiaFaq: false,
      };
    case asyncActionTypes.RETRIEVE_AMAIA_FAQ.FAIL:
      return {
        ...state,
        errorAmaiaFaq: action.payload,
        loadingAmaiaFaq: false,
      };
    case asyncActionTypes.SEARCH_AMAIA.START:
      return {
        ...state,
        errorAmaiaResponse: null,
        loadingAmaiaResponse: true,
        streamingMessage: '',
      };
    case asyncActionTypes.SEARCH_AMAIA_CHUNK.START:
      return {
        ...state,
        streamingMessage: state.streamingMessage + action.payload,
      };
    case asyncActionTypes.SEARCH_AMAIA.SUCCESS:
      return {
        ...state,
        loadingAmaiaResponse: false,
      };
    case asyncActionTypes.SEARCH_AMAIA.FAIL:
      return {
        ...state,
        errorAmaiaResponse: action.payload,
        loadingAmaiaResponse: false,
      };
    default:
      return state;
  }
};

export default PantheonData;